<template>
  <div>
    <v-container navy fluid pa-0>
      <v-container text-xs-center>
        <div>
          <svg width="34" height="17" viewBox="0 0 34 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32 17C33.1046 17 34.0122 16.1014 33.8825 15.0045C33.4366 11.2307 31.735 7.69333 29.0208 4.97919C25.8327 1.79107 21.5087 3.40396e-07 17 0C12.4913 -3.40396e-07 8.1673 1.79107 4.97919 4.97918C2.26504 7.69333 0.563424 11.2307 0.117464 15.0045C-0.0121661 16.1014 0.895431 17 2 17L17 17H32Z" fill="#FBC109" />
          </svg>
        </div>
        <h1 class="my-3 white--text">Get Started with Video Tutorials</h1>
        <p class="mb-0 white--text">Watch short tutorials to get started with Brainingcamp virtual math manipulatives!</p>
      </v-container>
      <v-container>
        <v-layout justify-center wrap>
          <v-flex xs6 sm2 mx-2 mb-3 class="card">
            <div>
              <img
                src="@/assets/tutorial-quickstart-thumb.png"
                alt="Getting started with Brainingcamp's digital math manipulatives."
              >
              <v-layout mt-3 wrap>
                <v-flex xs12 lg6>
                  <div
                    class="card_button"
                    tabindex="0"
                    @click="featureVideoCardClicked(848323422)"
                    @keydown.enter="featureVideoCardClicked(848323422)"
                  >
                    Play
                  </div>
                </v-flex>
                <v-flex xs12 lg6>
                  <a href="https://media.brainingcamp.com/static/pdfs/brainingcamp-quickstart.pdf" target="_blank">
                    <div
                      class="card_button white secondary--text"
                    >
                      View PDF
                    </div>
                  </a>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-flex xs6 sm2 mx-2 mb-3 class="card">
            <div>
              <img
                src="@/assets/tutorial-share-thumb.png"
                alt="How to use Share Codes"
              >
              <v-layout mt-3 wrap>
                <v-flex xs12 lg6>
                  <div
                    class="card_button"
                    tabindex="0"
                    @click="featureVideoCardClicked(888987281)"
                    @keydown.enter="featureVideoCardClicked(888987281)"
                  >
                    Play
                  </div>
                </v-flex>
                <v-flex xs12 lg6>
                  <a href="https://media.brainingcamp.com/static/pdfs/brainingcamp-share-codes.pdf" target="_blank">
                    <div
                      class="card_button white secondary--text"
                    >
                      View PDF
                    </div>
                  </a>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-flex xs6 sm2 mx-2 mb-3 class="card" v-if="!isStudent">
            <div>
              <img
                src="@/assets/tutorial-tasks-thumb.png"
                alt="Tasks by Brainingcamp"
              >
              <v-layout mt-3 wrap>
                <v-flex xs12 lg6>
                  <div
                    class="card_button"
                    tabindex="0"
                    @click="featureVideoCardClicked(811233213)"
                    @keydown.enter="featureVideoCardClicked(811233213)"
                  >
                    Play
                  </div>
                </v-flex>
                <v-flex xs12 lg6>
                  <a href="https://media.brainingcamp.com/static/pdfs/brainingcamp-tasks.pdf" target="_blank">
                    <div
                      class="card_button white secondary--text"
                    >
                      View PDF
                    </div>
                  </a>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-flex xs6 sm2 mx-2 mb-3 class="card" v-if="!isStudent">
            <div>
              <img
                src="@/assets/tutorial-live-thumb.png"
                alt="Live feature by Brainingcamp"
              >
              <v-layout mt-3 wrap>
                <v-flex xs12 lg6>
                  <div
                    class="card_button"
                    tabindex="0"
                    @click="featureVideoCardClicked(434523999)"
                    @keydown.enter="featureVideoCardClicked(434523999)"
                  >
                    Play
                  </div>
                </v-flex>
                <v-flex xs12 lg6>
                  <a href="https://media.brainingcamp.com/static/pdfs/brainingcamp-live.pdf" target="_blank">
                    <div
                      class="card_button white secondary--text"
                    >
                      View PDF
                    </div>
                  </a>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid ice class="manip_section">
        <v-container pa-0 style="max-width: 960px;">
          <v-layout justify-center>
            <v-flex>
              <v-layout row wrap justify-left align-top style="margin:auto">
                <v-flex xs6 sm4 md3 v-for="manip in manipulatives" :key="manip.id" @click="manipulativeIconDidClick(manip)" @keydown.enter="manipulativeIconDidClick(manip)"> 
                  <ManipulativeIconView :id="manip.id"/>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
    </v-container>
    <v-dialog v-model="showVideo" width="960">
      <v-layout wrap white>
        <v-flex xs12>
          <video v-if="showVideo" controls style="width:100%;" autoplay>
            <source :src="videoURL">
          </video>
        </v-flex>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
import manips from '@/data/manips.js'
import ManipulativeIconView from '@/components/ManipulativeIconView'

export default {
  components: {
    ManipulativeIconView
  },
  data: function () {
    return {
      activeManip: null,
      videoURL: null,
      showVideo: false
    }
  },
  computed: {
    manipulatives: function () {
      return [...manips]
    },
    isStudent: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.role === 'student'
      }
      return false
    }
  },
  mounted: function () {
  },
  methods: {
    manipulativeIconDidClick: function (manip) {
      this.videoURL = 'https://media.brainingcamp.com/v/' + manip.videoId + '.mp4'
      this.showVideo = true
    },
    featureVideoCardClicked: function (videoId) {
      this.videoURL = 'https://media.brainingcamp.com/v/' + videoId + '.mp4'
      this.showVideo = true
    }
  }
}
</script>

<style scoped>
.card_button {
  width: auto;
  background: #FBC109;
  color: black;
  padding: 4px 8px;
  border-radius: 100px;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
}
.manip_section {
  position: relative;
  border-radius: 280px 0 0 0;
}

.card {
  background: white;
  border-radius: 16px;
  border: 4px solid #D7EBFF;
  padding: 16px;
  height: 100%;
}

.card img {
  width: 100%;
  display: block;
}

.section_header {
  font-size: 24px;
  font-weight: bold;
  color: #3296f3;
}

.v-expansion-panel {
    box-shadow: none;
}
.theme--light.v-expansion-panel .v-expansion-panel__container {
  border-top: 2px solid #D7EBFF;
}

@media screen and (max-width: 1100px) {
  .manip_section {
    border-radius: 160px 0 0 0;
  }
}

@media screen and (max-width: 640px) {
  .manip_section {
    border-radius: 0;
  }
}
</style>

<style>
.v-expansion-panel__header {
  padding: 0;
}
</style>
